import { MESApiService, type spParameter } from "@dexteel/mesf-core";

export const loadMap = async (AssetId: string | number | null) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	parameters.push({ name: "AssetId", value: AssetId });

	const resp = await apiService.callV2("[MMS].[GetMap]", parameters);
	return resp;
};
